import global from "../global.js";
const log = global.log.getLogger("f_mtac.ui.InputNoteArea");
log.setLevel(log.levels.WARN);

let InputNoteArea = function () {
    var {Modal} = window.f_mtac_theme;
    var input_note_area_modal;
    var $input_note_area = document.getElementById("input_note_area");
    var $textarea = $("#input_note_area  textarea");

    const soft_wrap = (s) =>
        // Split the string between words before each line exceeds 32 characters.
        String(s)
            .replace(/(?![^\n]{1,32}$)([^\n]{1,32})\s/g, "$1\n")
            .split("\n");

    const capitalize = function (text) {
        return text === "" ? text : text.charAt(0).toUpperCase() + text.substr(1);
    };

    this.interact = function ({current_text = "", tip, capitalized = true, uppercase, validators, error_message, validate_change}) {
        input_note_area_modal = new Modal($input_note_area);
        let output = null;

        // Prepare the view
        $("#input_note_area .modal-title").text(tip);
        $("#input_note_area .invalid-feedback").text(error_message);
        $("#input_text_area input").css("text-transform", uppercase ? "uppercase" : "none");
        $textarea.attr("rows", "4");
        for (let validator in validators) {
            $textarea.attr(validator, validators[validator]);
        }
        $textarea.val(current_text);

        // User actions handlers
        let handlers = {
            ok: () => {
                if (!$textarea[0].checkValidity()) {
                    $("#input_note_area .invalid-feedback").show();
                    return;
                }
                if (validate_change) {
                    if (!validate_change($textarea.val())) {
                        $("#input_note_area .invalid-feedback").show();
                        return;
                    }
                }
                output = capitalized ? capitalize($textarea.val()) : $textarea.val();
                log.debug("Output:", output);
                input_note_area_modal.hide();
            },
            cancel: () => {
                input_note_area_modal.hide();
            },
            close: () => {
                input_note_area_modal.hide();
            }
        };

        // Manage events
        $input_note_area.addEventListener("shown.bs.modal", function () {
            $textarea.trigger("focus");
            $textarea[0].setSelectionRange(0, current_text.length);
        });

        $("#input_note_area .btn").on("click.input_note_area.btn", (event) => {
            let method = $(event.currentTarget).data("method");
            log.debug(method, "pressed.");
            handlers[method]();
        });

        $("body").on("keydown", async (event) => {
            if (event.ctrlKey && event.key === "Enter") {
                log.debug("Ctrl+Enter pressed.");
                // event.preventDefault();
                handlers["ok"]();
            }
        });

        $("#input_note_area  textarea").on("keyup", (event) => {
            if (event.ctrlKey && event.key === "v") {
                // The text will be validated when releasing the control key.
                // Doing the validation twice would clear the invalid feedback.
                return;
            }
            log.debug(event);
            log.debug(`Initial text:\n${$textarea.val()}`);
            let new_text = capitalized ? capitalize($textarea.val()) : $textarea.val();
            // check limits
            if (validate_change) {
                if (!validate_change(new_text)) {
                    $textarea.val(current_text);
                    $("#input_note_area .invalid-feedback").show();
                    return;
                }
            }
            // check validity
            if (!$textarea.get(0).checkValidity()) {
                $textarea.val(current_text);
                $("#input_note_area .invalid-feedback").show();
                return;
            }
            current_text = soft_wrap(new_text).join("\n");
            log.debug(`Final text:\n${current_text}`);
            $textarea.val(current_text);
            $("#input_note_area .invalid-feedback").hide();
        });

        return new Promise((resolve) => {
            let interaction_end = () => {
                for (let validator in validators) {
                    $textarea.removeAttr(validator);
                }
                $("#input_note_area .invalid-feedback").text("").hide();
                $input_note_area.removeEventListener("shown.bs.modal", interaction_end);
                $input_note_area.removeEventListener("hidden.bs.modal", interaction_end);
                $("body").off("keydown");
                $("#input_note_area .btn").off("click.input_note_area.btn");
                $("#input_note_area  textarea").off("keyup paste");
                output = output === "" ? null : output;
                log.debug("Interaction ended with output:", output);
                resolve(output);
            };

            $input_note_area.addEventListener("hidden.bs.modal", interaction_end);
            input_note_area_modal.show();
        });
    };
};
export default new InputNoteArea();
